export default {
    FILE_UPLOAD_START: ({commit, state}, payload) => {
        commit('SET_FILE_INFO', {
            data: payload
        });
    },
    FILE_UPLOAD_COMPLETED: ({commit, state}, payload) => {
        commit('SET_FILE_RESPONSE', {
            data: payload
        });
    }
}